import { render, staticRenderFns } from "./Proeditpril.vue?vue&type=template&id=68f2f294"
import script from "./Proeditpril.vue?vue&type=script&lang=js"
export * from "./Proeditpril.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports